import React from "react";
import { ButtonGroup, styled } from "@mui/material";


export default styled(ButtonGroup)`
  box-shadow: none;
  app-region: no-drag;
  pointer-events: initial;
`
